export class CollectionUtils {
    public static convertMapToSerializable<T, S>(map: Map<T, S>): object {
        const item = Object.create(null);
        map.forEach((val: S, key: T) => {
            item[key] = val;
        });
        return item;
    }
}
